export default "__VITE_ASSET__hZFj_uUH__"